var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('renewal-monitoring', {
    attrs: {
      "on-renewal": _vm.handleRenewal,
      "total": _vm.calculatedTotal,
      "renewal-data": _vm.renewalData,
      "product-data": _vm.productData
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-660cf097","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/renewalMonitoring/RenewalMonitoringContainer.vue
// module id = 1096
// module chunks = 0